module.exports = __webpack_public_path__ + "img/20400.7efb4615.jpg";